module.exports = __webpack_public_path__ + "static/img/fuyaotixing@3x.f6d9aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bingchengguanli/fuyaotixing@3x.png
// module id = PLto
// module chunks = 1